import { apiSnsCommentOrLike, apiSnsOperation } from "@/api/wx-chat/comment"
import { emojiNameStr } from "@/utils/weChatEmoji"
import { microAppSetData } from "@/micro/micro-app-utils"

// 评论中表情装换为具体的图片
function porcessEmoji(content) {
  // 匹配表情
  const emojiRegx = /\[.*?\]/gi
  // 使用 img 包裹表情
  const matchEmojis = [...new Set(content.match(emojiRegx))]
  matchEmojis?.forEach(item => {
    // 匹配属于表情的才做处理
    if (emojiNameStr.includes(item)) {
      // 如果匹配到则替换成表情图片
      content = content.replaceAll(
        item,
        `<img class="emoji" style="vertical-align: middle;" data-attr="${item}" src="https://tf-scrm-test.oss-cn-shenzhen.aliyuncs.com/weChatEmoji/${item}.png"/>`
      )
    }
  })
  return content
}
const state = {
  snsDetailObjectList: {}, // 全部信息
  friendInfo: {}, // 朋友圈信息
  commentContactObjectList: [], // 评论列表
  likeContactObjectList: [], // 点赞列表
  otherDetailInfo: {}, // 其他信息
  likeFlag: false, // 是否点赞
  commentNotifyList: [], // 通知列表
  resetPage: false // 刷新列表
}

const mutations = {
  UPDATE: (state, obj) => {
    for (const [key, value] of Object.entries(obj)) {
      if (state[key]) {
        state[key] = Object.assign({}, state[key], value)
      }
    }
  },
  CLEAN: (state, obj) => {
    state.commentContactObjectList = []
    state.likeContactObjectList = []
    state.firendInfo = {}
  },
  COMMENT_PUSH: (state, item) => {
    state.commentContactObjectList.push(item)
  },
  UPDATE_LIKE_LIST: (state, list) => {
    state.likeContactObjectList = list
  },
  LIKE_PUSH: (state, item) => {
    state.likeContactObjectList.push(item)
  },
  UPDATE_CONTACT_LIST: (state, list) => {
    state.commentContactObjectList = list
  },
  // 是否点赞
  LIKE_FLAG: (state, flag) => {
    state.likeFlag = flag
  },
  INIT_DATA: (state, obj) => {
    console.log(obj)
    console.log("vuex接受到信息")
    if (obj.code == 0) {
      const info = obj.snsDetailObjectList
      if (info && info.length > 0) {
        const item = info[0]
        state.likeContactObjectList = item.likeContactObjectList
        state.commentContactObjectList =
          (item.commentContactObjectList &&
            item.commentContactObjectList.map(ele => {
              let replyName = ""
              if (ele.replyUserName) {
                const idx = item.commentContactObjectList.findIndex(el => el.userName == ele.replyUserName)
                console.log("回复者")
                console.log(ele.replyUserName)
                console.log(item.commentContactObjectList)
                console.log(idx)
                if (idx > -1) {
                  replyName = item.commentContactObjectList[idx].nickName
                }
              }
              return {
                ...ele,
                content: porcessEmoji(ele.content),
                replyName
              }
            })) ||
          []
        // 判断是否点赞了
        if (item.likeContactObjectList.findIndex(el => el.userName == state.friendInfo?.oldUserName) > -1) {
          state.likeFlag = true
        } else {
          state.likeFlag = false
        }
        const firendInfo = {
          nickName: item.nickName,
          objectDesc: item.objectDesc,
          createTime: item.createTime
        }
        state.firendInfo = { ...state.friendInfo, ...firendInfo }
      }
    }
  },
  GET_COMMENT_NOTIFY_LIST: (state, list) => {
    state.commentNotifyList = list
  },

  // 刷新偶朋友圈评论列表
  RESET_PAGE: (state, resetPage) => {
    state.resetPage = resetPage
    microAppSetData("WCT", { type: "store", data: { fnType: "commit", nameSpace: "comment/RESET_PAGE", fnData: resetPage } })
  }
}

const actions = {
  // 回复
  requestReply({ commit, state }, data) {
    return apiSnsCommentOrLike(data).then(res => {
      return res.data
    })
  },
  // 取消点赞
  requestSnsOperation({ commit, state }, data) {
    return apiSnsOperation(data).then(res => {
      return res.data
    })
  },

  // 获取朋友圈评论通知记录
  requestCommentNotifyList({ commit, state }, data) {
    commit("GET_COMMENT_NOTIFY_LIST", data)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
